import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigCI/services/constants";

export const clearPublishRequests = createAction(`${moduleSlug}/CLEAR_PUBLISH_REQUEST`);

export const setTestTasks = createAction(`${moduleSlug}/SET_TEST_TASKS`);

export const getPublishRequest = createAction(`${moduleSlug}/PUBLISH_REQUEST`);
export const getPublishRequestSuccess = createAction(`${moduleSlug}/PUBLISH_REQUEST/SUCCESS`);
export const getPublishRequestError = createAction(`${moduleSlug}/PUBLISH_REQUEST/ERROR`);

export const getTestCases = createAction(`${moduleSlug}/GET_TEST_CASES`);
export const mergeTestCases = createAction(`${moduleSlug}/MERGE_TEST_CASES`);

export const configCiTestCaseTaskCancel = createAction(`${moduleSlug}/CONFIG_CI_TEST_CASE_TASK_CANCEL`);

export const setAcceptPublishRequestDialog = createAction(`${moduleSlug}/SET_ACCEPT_PUBLISH_REQUEST_DIALOG`);
export const mergeAcceptPublishRequestDialog = createAction(`${moduleSlug}/MERGE_ACCEPT_PUBLISH_REQUEST_DIALOG`);
export const acceptPublishRequest = createAction(`${moduleSlug}/ACCEPT_PUBLISH_REQUEST`);

export const rejectPublishRequest = createAction(`${moduleSlug}/REJECT_PUBLISH_REQUEST`);
